import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {of, ReplaySubject} from "rxjs";
import {PermissionsTag} from "../../../shared/interface/permissions-tag";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {Router} from "@angular/router";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {DictService} from "../../../shared/services/dict.service";
import {MatDialog} from "@angular/material/dialog";
import {AuthService} from "../../../shared/services/auth.service";
import {PermissionTagsService} from "../../../shared/services/permission-tags.service";
import {delay, takeUntil, tap} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {AddressImportRow} from "../../../shared/interface/address-import-row";
import {AddressImportRowService} from "../../../shared/services/address-import-row.service";

@Component({
  selector: 'app-address-add',
  templateUrl: './address-add.component.html',
  styleUrls: ['./address-add.component.scss']
})
export class AddressAddComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() addressImportRow?: AddressImportRow;
  @Input() mod = false;
  @Output() closeModification = new EventEmitter<any>();

  addressImportRowForm: FormGroup;
  typeControl: FormControl;
  valueControl: FormControl;
  processingRequest = false;
  formValid = false;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);
  private initialized: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private formHelper: FormHelperService,
    private snack: MatSnackBar,
    private dictService: DictService,
    private dialog: MatDialog,
    private authService: AuthService,
    private addressImportRowService: AddressImportRowService
  ) {
    this.addressImportRowForm = fb.group({
      id: fb.control(''),
      value: this.valueControl = this.fb.control('', [Validators.required]),
      type: this.typeControl = this.fb.control('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.addressImportRowForm.valueChanges
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => this.formValid = this.addressImportRowForm.valid);
  }

  ngAfterViewInit(): void {
    if (this.addressImportRow) {
      this.initialize(this.addressImportRow);
    } else {
      this.initialized.next(true);
    }
  }

  initialize(row: AddressImportRow): void {
    of(row)
      .pipe(
        delay(0),
        tap(() => {
          this.addressImportRowForm.reset({
            id: row.id,
            name: row.value,
            type: row.type.id
          });
        }),
        delay(0),
        tap(() => this.initialized.next(true))
      ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  cancel(): void {
    if (!this.addressImportRow) {
      this.router.navigate(['/baza-adresowa/lista']);
    } else {
      this.closeModification.emit();
    }
  }

  sendForm(): void {
    this.processingRequest = true;
    this.addressImportRowService.send(this.addressImportRowForm.value)
      .subscribe((response) => {
        this.snack.open(this.addressImportRow ? 'Pomyślnie zaktualizowano adres' : 'Pomyślnie dodano adres.', '', {
          duration: 2000,
        });
        if (this.addressImportRow) {
          this.closeModification.emit();
        } else {
          this.router.navigate(['/baza-adresowa/lista']);
        }
        this.processingRequest = false;
      }, (error: HttpErrorResponse) => {
        this.snack.open('Podczas dodawania adresu wystąpił błąd', error.status.toString(), {
          duration: 2000,
        });
        this.processingRequest = false;
      });
  }
}
